import TopManager from './page/top/top'
import AboutManager from './page/about/about'
import ServiceManager from './page/service/service'
import WorksManager from './page/works/works'
import WorksDetailManager from './page/works/worksDetail'
import ContactManager from './page/contact/contact'

import NewsManager from './page/news/news'
import NewsDetailManager from './page/news/newsDetail'
//import Luxy from './lib/luxy.js'
//import LocomotiveScroll from 'locomotive-scroll';

import { toggleActive } from './lib/inview'
import { autoplayVideos } from './lib/video'




export default class Manager {
	constructor() {
		this.w = window.innerWidth
		this.h = window.innerHeight

		this.pageID = document.getElementsByTagName('body')[0].getAttribute('id')
	}

	init() {
		document.getElementById('l-root').classList.add("active");

		//初期化
		//console.log(this);
		//console.log(Waypoint);

		//ページごと
		if (this.pageID === 'top') {
			const pageManager = new TopManager()
			pageManager.init()
		} else if (this.pageID === 'about') {
			const pageManager = new AboutManager()
			pageManager.init()
		} else if (this.pageID === 'service') {
			const pageManager = new ServiceManager()
			pageManager.init()
		} else if (this.pageID === 'works') {
			const pageManager = new WorksManager()
			pageManager.init()
		} else if (this.pageID === 'worksDetail') {
			const pageManager = new WorksDetailManager()
			pageManager.init()
		} else if (this.pageID === 'news') {
			const pageManager = new NewsManager()
			pageManager.init()
		} else if (this.pageID === 'newsDetail') {
			const pageManager = new NewsDetailManager()
			pageManager.init()
		} else if (this.pageID === 'contact') {
			const pageManager = new ContactManager()
			pageManager.init()
		}

		//console.log(TweenMax)

		this.loadCommon();
		this.scroll();
		this.resize();
	}
	loadCommon() {
		let preTop;


		/* ---------------------------------------
		sp
		--------------------------------------- */
		let button_container = document.getElementById('button_container');
		let overlay = document.getElementById('overlay');
		let toggle = document.getElementById('toggle');

		button_container.addEventListener('click', function (e) {
			button_container.classList.toggle('active');
			overlay.classList.toggle('open');
			toggle.classList.toggle('active');

			if (button_container.classList.contains("active")) {
				//open
				preTop = window.scrollY;

				document.querySelector('html').classList.add('hidden');
				document.querySelector('body').classList.add('hidden');
				//$("html, body").animate({ scrollTop: preTop }, 0, "swing");
			} else {
				//close
				document.querySelector('html').classList.remove('hidden');
				document.querySelector('body').classList.remove('hidden');
				//$("html, body").animate({ scrollTop: preTop }, 0, "swing");
			}
		})



		// 以前は querySelector で最初のリンクにしか付いていなかった
		document.querySelectorAll('#overlay ul li a').forEach((button_container_link) => button_container_link.addEventListener('click', function (e) {
			button_container.classList.remove('active');
			overlay.classList.remove('open');
			toggle.classList.remove('active');

			document.querySelector('html').classList.remove('hidden');
			document.querySelector('body').classList.remove('hidden');

			//$("html, body").animate({ scrollTop: preTop }, 0, "swing");
		}))






		toggleActive(document.getElementsByClassName('waypoint'))
		toggleActive(document.getElementsByClassName('letter'))
		toggleActive(document.getElementsByClassName('fade'))
		toggleActive(document.getElementsByClassName('fadeSimple'))
		toggleActive(document.getElementsByClassName('addActive'))

		autoplayVideos()


		window.dispatchEvent(new Event('resize'))
	}
	scroll() {
		//共通


		// Luxy.init({
		// 	wrapper: '#l-root', //慣性スクロールを包括する要素のID
		// 	targets: '.luxy-el', //パララックスの要素のclass名
		// 	wrapperSpeed: 0.08, //スクロールスピード
		// });

		// const scroll = new LocomotiveScroll({
		//	 el: document.querySelector('#l-root'),
		//	 smooth: true
		// });
	}
	resize() {
		window.addEventListener('resize', function (e) {
			this.w = window.innerWidth;
			this.h = window.innerHeight;
		})
	}

}
